import { render, staticRenderFns } from "./AssessmentInfo.vue?vue&type=template&id=4484ebd8&scoped=true&"
import script from "./AssessmentInfo.vue?vue&type=script&lang=js&"
export * from "./AssessmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentInfo.vue?vue&type=style&index=0&id=4484ebd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4484ebd8",
  null
  
)

export default component.exports